import { createFileRoute } from "@tanstack/react-router";
import { options } from "@/pages/how-to-animate-a-png";

export const Route = createFileRoute("/blog/how-to-animate-a-png")(options);
